
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppTinyInfo from "./TinyInfo.vue";
import {ChartService} from "@/services";
import { DashboardDataMonthOrQuarterOptionSelect } from "@/utils/dashboard/dashboard-data-month-or-quarter-option-select";

export default Vue.extend({
	data(){
		return {
			toPayVat: 0.0
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
	},
	computed: {
		chartData():DashboardDataMonthOrQuarterOptionSelect{
			return this.item.Data as DashboardDataMonthOrQuarterOptionSelect;
		},
		classes():string{
			if (this.toPayVat > 0) {
				return "open";
			}
			return "";
		}
	},
	methods: {
		async fetch(){
			this.toPayVat = await ChartService.getToPayVat(this.chartData.useQuarter);
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppTinyInfo
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
